import { Field, Formik } from "formik";
import { TextField as Textfield } from "formik-mui";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React, { useEffect, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import ContractorForm from "./ContractorForm";
import SubContractorForm from "./SubContractorForm";
import { initialContractorDetails, initialDetails, initialSubcontractorDetails } from "../../../utils/dtos";
import { ProjectSchema } from "../../../schemas/ProjectSchema";
import SelectInput from "../../SelectInput";
import useUploadMultipleImage from "../../../hooks/useUploadMultipleImage";
import { isEmpty } from "lodash";
import { useProject } from "../../../context/ProjectContext";
import dayjs from "dayjs";
import Spinner from "../../Loader/Spinner";
import { BsXCircle } from "react-icons/bs";
import moment from "moment";

const NewProjectForm = ({ close }) => {
  const options = ["Apartment","Condo", "Duplex", "Renovation", "Restoration after natural disaster", "Roof", "Triplex", "Other"];
  const { onChange, images, removeImage } = useUploadMultipleImage();
  const [errImage, setErrImage] = useState(false);
  const [addType, setAddType] = useState(false);
  const { setValues, createproject, setUploadImage, loader, done } = useProject();
  const [days, setDays] = useState([
    { day: "Monday", selected: false, pos: 1 },
    { day: "Tuesday", selected: false, pos: 2 },
    { day: "Wednesday", selected: false, pos: 3 },
    { day: "Thursday", selected: false, pos: 4 },
    { day: "Friday", selected: false, pos: 5 },
  ]);

  const handleSubmit = async (values) => {
    if (images.filter((image) => !!image.url).length !== 0) {
      setUploadImage(images.filter((image) => !!image.url));
      await createproject(false);
      setValues({ ...values, images: images.filter((image) => !!image.url), contractor: values.contractor[0] });
    } else {
      setErrImage(true);
    }
  };

  const handleWorkingDays = (index, setFieldValue) => {
    setDays(days.map((item, i) => (i === index ? { ...item, selected: !item.selected } : item)));
    const val = days
      .map((item, i) => (i === index ? { ...item, selected: !item.selected } : item))
      .filter((item) => item.selected);
      
      setFieldValue(
        "workingDays",
        val.map((item) => item.day)
      );
    const interval = Math.max(...val.map(item => item.pos))
    const endDate = moment().day(interval + 7).toISOString()
    setFieldValue("endDate", dayjs(endDate).format("YYYY-MM-DD"))
  };


  useEffect(() => {
    done && close();
  }, [close, done]);

  return (
    <div className="px-[40px] pb-[32px] w-[300px] md:w-full h-[auto]">
      <Formik
        onSubmit={handleSubmit}
        initialValues={{
          ...initialDetails,
          contractor: [initialContractorDetails],
          subContractor: [initialSubcontractorDetails],
        }}
        validationSchema={ProjectSchema}
      >
        {({ handleSubmit, values, errors, setFieldValue }) => (
          <div className="w-full flex flex-col items-center justify-center ">
            <div className="pt-6">
              <div className="mt-1 relative flex md:justify-end">
                <Field
                  name={"nickName"}
                  label="Nickname"
                  value={values.nickName || ""}
                  placeholder="i.e Guest Bathroom, remodel, backyard fence, etc"
                  component={Textfield}
                  className="border w-full md:w-[360px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                />
              </div>
            </div>

            {!addType  && <div className="pt-6">
              <SelectInput options={options} handleChange={(value) => {
                if(value !== 'Other'){
                  setFieldValue("projectType", value)
                  setAddType(false)
                }else{
                  setFieldValue("projectType", '')
                  setAddType(true)
                }
              }} label="Project Type" />
              {errors?.projectType && <div className="text-red-600 text-[0.74rem] ml-2 font-roboto">{errors?.projectType}</div>}
            </div>}

            {addType && <div className="pt-6">
              <div className="mt-1 relative flex md:justify-end">
                <Field
                  name={"projectType"}
                  label="Add Project Type"
                  value={values.projectType || ""}
                  placeholder="i.e Guest Bathroom, remodel, backyard fence, etc"
                  component={Textfield}
                  className="border w-full md:w-[360px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                />
                <span onClick={() => setAddType(false)} className="absolute top-4 hover:text-red-800 font-semibold text-xl cursor-pointer right-3">
                  <BsXCircle />
                </span>
              </div>
            </div>}
            <div className="pt-8 w-full md:w-[360px]">
              <p className="font-bold self-start pb-4 text-black text-[14px]">Upload Property Images before Disaster</p>
              <div className="flex md:flex-row flex-col gap-4">
                {images.map((item, index) => (
                  <div className="w-full relative" key={index}>
                    <label htmlFor={`imageUpload${index}`}>
                      {isEmpty(item) ? (
                        <div className="flex flex-col  h-[135px] gap-1 px-6 py-[20px] rounded-xl items-center justify-center border-dashed border-primary border-[1.4px]">
                          <p className="text-[20px]">
                            <i className="fa-solid fa-circle-plus mr-1 text-primary"></i>
                          </p>
                        </div>
                      ) : (
                        <div className="flex flex-col  h-[135px] gap-1 rounded-xl items-center justify-center relative border-dashed border-primary border-[1.4px]">
                          <img src={item?.url} alt="alt" className="w-full h-[135px] rounded-xl object-cover" />
                        </div>
                      )}
                    </label>
                    {item.url && (
                      <i
                        className="fa-solid fa-circle-xmark text-white bg-primary rounded-full fa-2x scale-55 z-50 absolute top-[40%] left-[35%] cursor-pointer"
                        onClick={() => removeImage(index)}
                      ></i>
                    )}
                    <input
                      id={`imageUpload${index}`}
                      type="file"
                      accept="image/*"
                      className="w-0.1 h-0.1 overflow-hidden hidden"
                      onChange={(event) => {
                        onChange(event, index);
                      }}
                    />
                  </div>
                ))}
              </div>
              {errImage && <div className="text-red-600 text-[0.74rem] ml-2 font-roboto">Upload at least one image</div>}
            </div>
            <div className="pt-6 ">
              <div className="mt-1 relative flex">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    label="Select Start Date"
                    components={{ OpenPickerIcon: () => <i className="fa-solid fa-calendar-days text-primary"></i> }}
                    className="w-full md:w-[360px]"
                    inputFormat="DD-MMM-YYYY"
                    disableMaskedInput={true}
                    value={values?.startDate}
                    onChange={(value) => setFieldValue("startDate", dayjs(value).format("YYYY-MM-DD"))}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </div>
              {errors?.startDate && <div className="text-red-600 text-[0.74rem] ml-2 font-roboto">{errors?.startDate}</div>}
            </div>
            <div className="pt-6">
              <p className="font-bold self-start pb-4 text-black text-[14px]">Select Working Days</p>
              <div className="mt-1 relative flex  md:flex-row flex-col gap-3  w-full md:w-[360px] overflow-x-scroll no-scrollbar">
                {days.map((item, index) => (
                  <button
                    key={index}
                    onClick={() => handleWorkingDays(index, setFieldValue)}
                    className={`w-[200px]  md:w-[120px] px-4 h-[40px] ${
                      item.selected ? "bg-primary text-white rounded" : "border border-primary rounded text-primary"
                    } text-[12px] flex items-center justify-center`}
                  >
                    {item.day}
                  </button>
                ))}
              </div>
              {errors?.workingDays && <div className="text-red-600 text-[0.74rem] ml-2 font-roboto">{errors?.workingDays}</div>}
            </div>
            <div className="pt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
              <>
                <div className="mt-1 relative flex md:justify-end">
                  <Field
                    name={"totalProjectDays"}
                    label="Total Project Days"
                    value={values.totalProjectDays || ""}
                    placeholder="0 day"
                    component={Textfield}
                    className="border w-full md:w-[175px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                  />
                </div>
              </>
              <div>
                <div className="mt-1 relative flex md:justify-end">
                  {" "}
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="Project End Date"
                      components={{ OpenPickerIcon: () => <i className="fa-solid fa-calendar-days text-primary"></i> }}
                      className="w-full md:w-[175px]"
                      inputFormat="DD-MMM-YYYY"
                      disableMaskedInput={true}
                      value={values?.endDate}
                      onChange={(value) => setFieldValue("endDate", dayjs(value).format("YYYY-MM-DD"))}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </div>
                {errors?.endDate && <div className="text-red-600 text-[0.74rem] ml-2 font-roboto">{errors?.endDate}</div>}
              </div>{" "}
            </div>
            <hr className="mb-6 mt-8 w-full" />
            <ContractorForm Textfield={Textfield} values={values} />
            <hr className="mb-6 mt-8 w-full" />
            <SubContractorForm Textfield={Textfield} values={values} />
            <button
              type="submit"
              onClick={handleSubmit}
              className="h-[50px] border border-primary px-12 rounded mt-16 text-primary hover:bg-primary hover:text-white"
            >
              {loader ? <Spinner /> : "Submit"}
            </button>
          </div>
        )}
      </Formik>
    </div>
  );
};

export default NewProjectForm;
